import { Button, Input, Modal, Popconfirm, message, Select } from 'antd';
import { FC, useEffect, useState } from 'react';
import baseuri from '../../methods/baseuri';
import { useAppSelector, useAppDispatch } from '../../methods/redux/hooks';
import { retrievePaymentGateways } from '../../methods/redux/reducers/payment-gateway';

interface IEditCron {
	item: any;
}
const ManualPayout: FC<IEditCron> = ({ item }) => {
	const [visible, setVisible] = useState(false);
		const dispatch = useAppDispatch();
	
	const [data, setData] = useState({
		paymentGatewayId: item.paymentGatewayId?._id,
		requestId: item?._id,
	});
	const { payementgateways } = useAppSelector((store) => store.paymentGateway);

	useEffect(() => {
		dispatch(
			retrievePaymentGateways({
				pageId: '1',
				perPage: '100',
			})
		);
	}, []);
	const handlePayout = async () => {
		try {
			const res: any = await baseuri.post(
				`admin/wallet/trigger-fiat-gateway-payout`,
				data
			);
			if (res.status === 200) {
				message.success(res.data.message);
				setVisible(false);
			} else {
				message.info(res.data.message);
			}
		} catch (e: any) {
			message.error(e.response.data.message);
		}
	};

	return (
		<>
			<Button onClick={() => setVisible(true)}>
				{Number(item?.status) === 2
					? 'Trigger Manual Pay out'
					: 'Payout Withdrawal'}
			</Button>

			<Modal
				title="Payout Fiat Withdrawal"
				visible={visible}
				footer={[
					<Popconfirm title="Are you sure?" onConfirm={handlePayout}>
						<Button type="primary">Process Payout</Button>
					</Popconfirm>,
				]}
				onCancel={() => setVisible(false)}
			>
				<Select
					style={{ width: '100%' }}
					placeholder={item?.paymentGatewayId?.name}
					value={data.paymentGatewayId}
					onChange={(value: any) =>
						setData((prev) => ({ ...prev, paymentGatewayId: value }))
					}
				>
					{payementgateways.itemsList?.map((option: any) => (
						<Select.Option value={option._id} key={option._id}>
							{option.name}
						</Select.Option>
					))}
				</Select>
			</Modal>
		</>
	);
};

export default ManualPayout;
